// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__uWzbE","text":"SelectPayment_text__d0Pbz","title":"SelectPayment_title__HiDnI","btn":"SelectPayment_btn__2KdeS"};